import { ListItem } from 'components/shared/NumberedList';

export const COPY = {
  header: 'Request a no-obligation quote from {{trading_name}}',
  body: "If you would like to request a callback to discuss having some work done, just provide us with some basic information. We have also partenered with Ideal4Finance to offer finance on our quotes. You can let us know if you are interested in finance here too. Here's how it works:",
};

export const LIST: ListItem[] = [
  {
    header: 'Provide Some Contact and Work Information',
    content:
      'This lets us know how best to contact you, and some understanding of what needs doing',
  },
  {
    header: 'Set a Project Budget',
    content:
      "Set an estimated budget for your project, and let us know if you're interested in finance.",
  },
  {
    header: 'Receive a Quote',
    content:
      'We will reach out to you about this enquiry, and get you set up with a no-obligation quote.',
  },
];
